import { useEffect, useState } from "react";
import Head from "next/head";
import Layout from "layout/Layout/index.js";
import Image from "next/image";
import SSS from "components/SSS/SSS";
import { getCurrencyRates, getWindowsServers } from "services/allServices";
import Loader from "react-loader-spinner";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import productInfoJson from "ProductInfo.json";
import { useGlobalStore } from "store/GlobalStore";
import { useTranslation } from "next-i18next";
import SSSData from "public/SSS/sss-tr-windows-sanal-sunucu.json";
import SSSDataEN from "public/SSS/sss-en-windows-sanal-sunucu.json";
import { useRouter } from "next/router";
import VirtualServersTable from "@/components/WindowsVirtualServers/VirtualServersTable";
import WindowsVirtualServersServices from "components/WindowsVirtualServers/WindowsVirtualServerServices";
import DidntFindForm from "components/PhysicalServers/DidntFindForm";
import WhatIsVirtualServer from "@/components/WindowsVirtualServers/WhatIsVirtualServer";
import TechnicalSpecificationsWindowsServers from "@/components/WindowsVirtualServers/TechnicalSpecificationsWindowsServers";
import SecureAndUniqueVirtualServers from "@/components/WindowsVirtualServers/SecureAndUniqueVirtualServers";
import DiscoverPowerOfMakdos from "@/components/WindowsVirtualServers/DiscoverPowerOfMakdos";
import MaxPerformanceWebSiteCloudServer from "@/components/CloudServers/MaxPerformanceWebSiteCloudServer";

function virtualServers({ datas, rates }) {
    const { t } = useTranslation("common");
    const router = useRouter();
    const [servers, setServers] = useState();
    const [setCurrencyRates] = useGlobalStore((state) => [state.setCurrencyRates]);

    const onGetVirtualServers = () => {
        let sortedData = datas.sort((a, b) => a.order - b.order);
        setServers(sortedData);
    };

    useEffect(() => {
        onGetVirtualServers();
    }, []);
    useEffect(() => {
        setCurrencyRates(rates);
    }, [rates]);
    return (
        <Layout>
            <Head>
                <title>{t('windowsMetaTitle')}</title>
                <meta name="description" content={t('windowsMetaDescription')} />
                <meta property="og:title" content={t('windowsMetaTitle')} key="title" />
                <meta property="og:description" content={t('windowsMetaDescription')} key="description" />
            </Head>
            <div className="w-full bg-no-repeat transform-gpu bg-physicalServerBg" >
                <div className="container px-4 pt-20 pb-10 mx-auto lg:px-0">
                    <div className="flex items-center justify-between mb-14">
                        <div className="flex-1">
                            <p className="text-xl">{t("windowsCloudServer:title")}</p>
                            <h1 className="my-3 text-5xl font-semibold">{t("windowsCloudServer:title2")}</h1>
                            <div dangerouslySetInnerHTML={{ __html: t("windowsCloudServer:description") }} />
                        </div>
                        <div className="justify-end flex-1 hidden lg:flex w-[329px] h-[118px]">
                            <Image
                                src="/virtualServerPriority.png"
                                alt={t("windowsCloudServer:title2")}
                                title={t("windowsCloudServer:title2")}
                                width="329"
                                height="118"
                                priority
                                loading="eager"
                                className="transform-gpu"
                            />
                        </div>
                    </div>
                    {servers ?
                        <div className="w-full p-8 mb-20 overflow-x-auto bg-white rounded-md shadow-lg">
                            <VirtualServersTable servers={servers} />
                        </div>
                        :
                        <div className="flex justify-center w-full py-20">
                            <Loader
                                type="Oval"
                                color="#FFDD00"
                                height={50}
                                width={50}
                                timeout={3000} //3 secs
                            />
                        </div>
                    }
                    <div className="grid grid-cols-2">
                        <div className="flex items-center col-span-2 lg:col-span-1">
                            <Image
                                src={"/virtualServers.svg"}
                                alt={t("windowsCloudServer:virtualServerHeading")}
                                title={t("windowsCloudServer:virtualServerHeading")}
                                width={560}
                                height={460}
                            />
                        </div>
                        <div className="col-span-2 pt-10 lg:col-span-1">
                            <h2 className="py-8 text-4xl font-semibold lg:text-5xl">
                                {t("windowsCloudServer:virtualServerHeading")}

                                {/* <span
                                    className="relative text-4xl font-semibold text-after-shadow lg:text-5xl">{t("windowsCloudServer:heading1")}</span>
                                <span
                                    className="relative text-4xl font-semibold w-fit text-after-shadow lg:text-5xl">{t("windowsCloudServer:heading2")}</span> */}
                            </h2>

                            <p className="text-cardText text-md">{t("windowsCloudServer:paragraph1")}</p>
                            <br />
                            <p className="text-cardText text-md">{t("windowsCloudServer:paragraph2")}</p>
                            <br />
                        </div>
                    </div>
                </div>
            </div>

            <WindowsVirtualServersServices servers={servers} />

            <WhatIsVirtualServer />

            <TechnicalSpecificationsWindowsServers />

            <SecureAndUniqueVirtualServers />

            <DiscoverPowerOfMakdos />

            <div className="mt-20">
                <SSS data={router.locale === "tr" ? SSSData : SSSDataEN} />
            </div>
            <DidntFindForm />
        </Layout>
    );
}

export default virtualServers;

export const getServerSideProps = async ({ locale }) => {
    let datas = {};
    await getWindowsServers(productInfoJson.windows_server).then(res => {
        datas = res.map((server) => ({ //bütün dataları atmayıp performans iyileştirmek için
            product_name: server.product_name,
            cpu: server.cpu,
            cpu_core: server.cpu_core,
            ram: server.ram,
            disk: server.disk,
            one_month_price: server.one_month_price,
            currency: server.currency,
            stock: server.stock,
            network: server.network,
            id: server.id,
        }));
    });
    let rates = {};
    await getCurrencyRates().then(res => {
        rates = res;
    });

    return {
        props: {
            ...await serverSideTranslations(locale, ["common", "nav", "windowsCloudServer", "windowsLang"]),
            datas: datas,
            rates: rates
        }
    };
};